import { TaskType } from '@prisma/client';

export const TASK_TYPE_ICON = {
  [TaskType.Classification]: 'folder-tree',
  [TaskType.Extraction]: 'magnifying-glass-arrow-right',
  [TaskType.Generation]: 'gear',
  [TaskType.Summarization]: 'book', 
  [TaskType.Autocompletion]: 'wand-magic-sparkles',
} as const;
